export default __webpack_public_path__ + "static/media/anatoly.da45f678.png";